import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, X } from "lucide-react";
import api, { getErr } from "../../lib/api";
import { NeonCard, Spinner, EmptyState, Pill } from "../../components/Neon";
import { gbp, fmtDateTime } from "../../lib/format";

export default function AdminCashouts() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => api.get("/admin/cashouts").then(({ data }) => setList(data || [])).catch(() => {}).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const decide = async (id, approve) => {
    try { await api.post(`/admin/cashouts/${id}`, { approve }); toast.success(approve ? "Approved." : "Rejected."); load(); }
    catch (e) { toast.error(getErr(e)); }
  };

  if (loading) return <Spinner />;
  return (
    <div data-testid="admin-cashouts">
      <h2 className="font-display uppercase text-2xl text-white">Cash-out Requests</h2>
      {list.length === 0 ? <div className="mt-4"><EmptyState title="No cash-out requests" /></div> : (
        <NeonCard variant="soft" className="mt-4" innerClassName="p-0">
          <div className="overflow-x-auto"><table className="w-full text-sm">
            <thead><tr className="text-left text-[var(--text-muted)] border-b border-white/10"><th className="p-3">User</th><th>Amount</th><th>Status</th><th>Requested</th><th className="text-right p-3">Actions</th></tr></thead>
            <tbody>
              {list.map((c) => (
                <tr key={c.id} className="border-b border-white/5">
                  <td className="p-3 text-white">{c.user_email || c.full_name || c.user_id}</td>
                  <td className="glow-green">{gbp(c.amount)}</td>
                  <td><Pill color={c.status === "approved" ? "green" : c.status === "rejected" ? "pink" : "cyan"}>{c.status}</Pill></td>
                  <td className="text-[var(--text-muted)]">{fmtDateTime(c.created_at)}</td>
                  <td className="p-3"><div className="flex items-center justify-end gap-1">
                    <button onClick={() => decide(c.id, true)} className="p-2 rounded-lg hover:bg-white/10 text-[var(--neon-green)]" data-testid={`approve-cashout-${c.id}`}><Check className="h-4 w-4" /></button>
                    <button onClick={() => decide(c.id, false)} className="p-2 rounded-lg hover:bg-white/10 text-[var(--neon-pink)]"><X className="h-4 w-4" /></button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table></div>
        </NeonCard>
      )}
    </div>
  );
}
